import { useEffect, useState } from "react";
import { IoIosClose } from "react-icons/io";
import Header from "../../components/header/index.jsx";
import { Loading } from "../../components/loading";
import { getIfoodRequests } from "../../scripts/getIfoodRequests.js";
import RequestsList from "./components/requestsList/index.jsx";
import styles from "./css/ifoodRequests.module.css";


export default function IfoodRequests() {

    const [requests, setRequests] = useState([]);
    const [requestsRender, setRequestsRender] = useState([]);

    // SEARCH CONTROL
    const [search, setSearch] = useState('');

    // LOADING CONTROL
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        const initScreen = async () => {
            try {
                await handleGetRequests();

            } catch (e) {
                console.error('ERROR - INIT SCREEN:', e);

            } finally {
                setLoading(false);
            }
        }

        initScreen();

    }, []);


    const handleGetRequests = async () => {
        try {
            setLoading(true);

            const res = await getIfoodRequests();

            setRequests(res);
            setRequestsRender(res);

        } catch (e) {
            throw e;

        } finally {
            setLoading(false);
        }
    }


    // CONTROLLER DE MUDANÇA DE VALOR NO INPUT DE BUSCA
    const onChangeSearch = ({ target: { value } }) => {
        setSearch(value.toLowerCase());

        if (value) {
            const array = requests.filter((item) =>
                item.company_name?.toLowerCase().includes(value.toLowerCase()) ||
                item.company_document?.toLowerCase().includes(value.toLowerCase()) ||
                item.company_email?.toLowerCase().includes(value.toLowerCase()) ||
                item.merchant_id?.toLowerCase().includes(value.toLowerCase())
            );

            setRequestsRender(array);

        } else {
            setRequestsRender(requests);
        }
    }


    // SCREEN ====================================>
    return (
        <div>
            <Header>
                <h2 style={{ color: '#fff' }}>Integrações iFood</h2>

                <div className={styles.searchBar}>
                    <input
                        className={styles.inputSearchStyle}
                        placeholder="Buscar por nome, CNPJ, email..."
                        onChange={onChangeSearch}
                        value={search}
                    />

                    <button
                        className={styles.clearSearchButton}
                        onClick={() => {
                            if(search.length > 0){
                                setSearch('');
                                setRequestsRender(requests);
                            }
                        }}
                    >
                        <IoIosClose size={22} color={search.length > 0 ? 'red' : 'grey'}/>
                    </button>
                </div>
            </Header>


            <div className={styles.container}>
                <div className={styles.contentArea}>

                    {loading ? (
                        <Loading />

                    ) : requests.length > 0 ? (
                        <>
                            {requestsRender.length === 0 ? (
                                <p className={styles.noDataText}>
                                    Nenhuma solicitação encontrada para a busca realizada.
                                </p>

                            ) : (
                                <RequestsList requests={requestsRender} />
                            )}
                        </>

                    ) : (
                        <p className={styles.noDataText}>
                            Nenhuma empresa solicitou integração com o iFood até o momento.
                        </p>
                    )}

                </div>
            </div>
        </div>
    );
}
